function download(options: { filename: string, data: any }) {
    const link = document.createElement('a');
    link.addEventListener('click',
        ($event) => {
            $event.stopPropagation();
        },
    );
    // Give it some invisibility
    link.style.setProperty('display', 'none');
    // Create the url for the link with the data
    const url = window.URL.createObjectURL(options.data);
    // Set link properties
    link.href = url;
    link.download = options.filename;
    // Simulate a click on it
    document.getElementsByTagName('body')[0].appendChild(link);
    link.click();
    // Remove the link after the operation is done
    setTimeout(() => {
        document.getElementsByTagName('body')[0].removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);
}

export default {
    download: (options: { filename: string, data: any }) => download(options),
};
